<template>
  <div class="user-wrapper">
    <div class="content-box">
      <a-dropdown>
        <span class="action ant-dropdown-link user-dropdown-menu">

          <img v-if="user.avatar" :src="`${user.avatar.indexOf('app/')>-1? constv.QINIU_AVATAR_CND_URL : constv.QINIU_IMAGE_USERRESOURCE_CND_URL}${user.avatar}`" class="avatar" alt="">
          <span v-else class="avatar-icon"></span>
          <a :title="user.nickname" ><span style="margin-left:10px;color:#999999;">{{ showText(user.nickname, 16) }}</span></a>

          <!-- <a-avatar
            class="avatar"
            size="small"
            :src="require('@/assets/img/avatar_default.png')"
          /> -->
        </span>
        <a-menu
          slot="overlay"
          class="user-dropdown-menu-wrapper"
        >
          <!-- <a-menu-item key="0">
            <router-link :to="{ name: 'center' }">
              <a-icon type="user"/>
              <span>个人中心</span>
            </router-link>
          </a-menu-item>
          <a-menu-item key="1">
            <router-link :to="{ name: 'settings' }">
              <a-icon type="setting"/>
              <span>账户设置</span>
            </router-link>
          </a-menu-item>
          <a-menu-item key="2" disabled>
            <a-icon type="setting"/>
            <span>测试</span>
          </a-menu-item> -->
          <a-menu-item key="0">
            <router-link :to="{path:'/manageUser/account'}"><a-icon type="idcard" /><span>账号信息</span></router-link>
          </a-menu-item>
          <!-- <a-menu-item key="1">
            <router-link :to="{path:'/manageUser/assets'}"> <span class="anticon"><assets width="1em" height="1em"></assets></span><span>资产管理</span></router-link>
          </a-menu-item> -->
          <a-menu-item key="2">
            <router-link :to="{path:'/user/resetPassword'}"><a-icon type="setting" /> <span>修改密码</span></router-link>
          </a-menu-item>

          <a-menu-item key="3">
            <a
              href="javascript:;"
              @click="handleLogout"
            >
              <a-icon type="logout" />
              <span>退出登录</span>
            </a>
          </a-menu-item>

        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
import { assets } from '@/core/icons'
import NoticeIcon from '@/components/NoticeIcon'
import { mapActions } from 'vuex'
import { showText } from '@/utils/util.js'
export default {
  name: 'UserMenu',
  components: {
    NoticeIcon,
    assets
  },
  data () {
    return {

    }
  },
  computed: {
    user () {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    showText,
    ...mapActions(['Logout']),
    handleMenuClick () {

    },
    handleLogout () {
      const that = this

      this.$confirm({
        centered: true,
        title: '提示',
        content: '真的要退出登录吗 ?',
        onOk () {
          return that.Logout({}).then(() => {
            sessionStorage.clear()
            window.location.reload()
          }).catch(err => {
            that.$message.error({
              title: '错误',
              description: err.message
            })
          })
        },
        onCancel () {
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.layout.ant-layout .header .user-wrapper .action, .layout.ant-layout .top-nav-header-index .user-wrapper .action {
  display: flex;
  align-items: center;
}
/deep/
.ant-dropdown-menu-item-active > a, .ant-dropdown-menu-submenu-title > a{
    color: @primary-color;
}

/deep/
.ant-dropdown-menu-item> a, .ant-dropdown-menu-submenu-title > a{
   padding-left: 24px;
}

/deep/
.user-dropdown-menu-wrapper .ant-dropdown-menu-item{
  width: 128px;
}

.content-box {
  .avatar {
    width: 32px;
    height: 32px;
    display: block;
    border-radius: 50%;
    border: 1px solid #F2F2F2;
  }
}

</style>
